import { SVGProps } from 'react'

export const ImpactPlan = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='254'
    height='177'
    viewBox='0 0 254 177'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <rect
      x='28.4784'
      y='32.6458'
      width='194.561'
      height='143.634'
      rx='3.98626'
      fill='#B2CAE0'
    />
    <rect
      x='23.4459'
      y='25.6343'
      width='195.859'
      height='145.237'
      rx='3.54034'
      fill='#B2CAE0'
      stroke='#003263'
      strokeWidth='0.891843'
    />
    <path
      d='M43.9027 128.348L197.373 128.893'
      stroke='white'
      strokeWidth='4.52223'
      strokeLinecap='round'
    />
    <path
      d='M43.9027 139.264L197.373 139.837'
      stroke='white'
      strokeWidth='4.52223'
      strokeLinecap='round'
    />
    <path
      d='M43.9027 150.18L197.373 150.753'
      stroke='white'
      strokeWidth='4.52223'
      strokeLinecap='round'
    />
    <rect
      x='151.167'
      y='46.9275'
      width='50.6067'
      height='70.9564'
      rx='1.7084'
      fill='#E8F0F6'
    />
    <rect
      x='41.1523'
      y='46.9275'
      width='50.6067'
      height='70.9564'
      rx='1.7084'
      fill='#E8F0F6'
    />
    <rect
      x='96.9637'
      y='46.5458'
      width='50.6067'
      height='70.9564'
      rx='1.7084'
      fill='#E8F0F6'
    />
    <line
      y1='-0.710894'
      x2='22.9937'
      y2='-0.710894'
      transform='matrix(0.436957 0.899483 -0.90212 0.431486 194.52 56.0206)'
      stroke='white'
      strokeWidth='1.42179'
      strokeDasharray='2.84 2.84'
    />
    <path
      d='M214.905 26.6414L218.281 18.501L225.708 14.8008L218.281 11.1006L214.905 2.96014L211.529 11.1006L204.102 14.8008L211.529 18.501L214.905 26.6414Z'
      fill='white'
    />
    <path
      d='M214.905 44.4024L211.529 52.5428L204.102 56.243L211.529 59.9432L214.905 68.0837L218.281 59.9432L225.708 56.243L218.281 52.5428L214.905 44.4024Z'
      fill='white'
    />
    <path
      d='M194.65 28.1215L187.898 11.8406L181.146 28.1215L166.293 35.5219L181.146 42.9223L187.898 59.2032L194.65 42.9223L209.504 35.5219L194.65 28.1215ZM190.572 38.4525L187.898 44.9056L185.224 38.4525L179.337 35.5219L185.224 32.5913L187.898 26.1382L190.572 32.5913L196.459 35.5219L190.572 38.4525Z'
      fill='white'
    />
    <path
      d='M188.018 18.7229L193.933 31.3841L194.383 31.8316L205.553 37.0001L194.393 41.9902L193.908 42.5026L189.071 55.0975L184.053 42.4921L183.556 41.9832L171.892 37.0323L182.806 32.5889L183.33 32.0399L188.018 18.7229Z'
      stroke='#003F7E'
      strokeWidth='1.84832'
      strokeLinejoin='bevel'
    />
    <path
      d='M212.926 5.96737L215.479 12.2305L215.577 12.4701L215.806 12.5909L220.854 15.2542L215.785 18.1464L215.579 18.2643L215.484 18.4829L212.952 24.3693L211.07 18.5453L210.985 18.2804L210.742 18.144L205.507 15.2038L210.272 12.2905L210.475 12.1665L210.562 11.9454L212.926 5.96737Z'
      stroke='#003F7E'
      strokeWidth='1.42179'
    />
    <path
      d='M212.926 48.4454L215.489 54.1609L215.595 54.3984L215.83 54.511L220.74 56.8655L215.81 59.4223L215.597 59.5327L215.495 59.7493L212.951 65.1252L211.064 59.8153L210.969 59.5489L210.717 59.4203L205.613 56.814L210.246 54.2385L210.457 54.1215L210.553 53.9007L212.926 48.4454Z'
      stroke='#003F7E'
      strokeWidth='1.42179'
    />
    <line
      y1='-0.710894'
      x2='22.9937'
      y2='-0.710894'
      transform='matrix(0.436957 0.899483 -0.90212 0.431486 194.685 57.5563)'
      stroke='#003263'
      strokeWidth='1.42179'
      strokeDasharray='2.84 2.84'
    />
    <line
      y1='-0.710894'
      x2='18.6932'
      y2='-0.710894'
      transform='matrix(0.467738 0.883867 -0.886838 0.46208 222.256 68.1451)'
      stroke='white'
      strokeWidth='1.42179'
      strokeDasharray='2.84 2.84'
    />
    <line
      y1='-0.710894'
      x2='18.6932'
      y2='-0.710894'
      transform='matrix(0.467738 0.883867 -0.886838 0.46208 220.703 68.2329)'
      stroke='#003263'
      strokeWidth='1.42179'
      strokeDasharray='2.84 2.84'
    />
    <line
      y1='-0.710894'
      x2='18.6956'
      y2='-0.710894'
      transform='matrix(0.485619 0.87417 -0.877339 0.479871 221.457 24.0508)'
      stroke='white'
      strokeWidth='1.42179'
      strokeDasharray='2.84 2.84'
    />
    <line
      y1='-0.710894'
      x2='18.6956'
      y2='-0.710894'
      transform='matrix(0.485619 0.87417 -0.877339 0.479871 219.905 24.17)'
      stroke='#003263'
      strokeWidth='1.42179'
      strokeDasharray='2.84 2.84'
    />
  </svg>
)
